import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'recap-component',
    templateUrl: './recap-paiement.component.html',
    host: { 'class': 'page' }
})
export class RecapPaiementComponent {
    transactionId: String;
    etat: String;
  montant: number;


    constructor(private router: Router, private route: ActivatedRoute) {
    }

    ngOnInit() {
      this.montant = 0;
        this.etat = this.route.snapshot.queryParams['etat'];
        this.transactionId = this.route.snapshot.queryParams['transactionId'];
        this.montant = this.route.snapshot.queryParams['amount'];
      let partieEntiere = this.montant / 100;
      let reste = this.montant % 100;
      this.montant = parseFloat('' + partieEntiere + '.' + reste + '');
    }

    goToModePaiement() {
        this.router.navigate(['cerba/mode-paiement']);
    }

    isEtatSuccess() {
      if (this.etat == 'ACCEPTED') {
            return true;
        } else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/pages/cerba/pages/recap-paiement/recap-paiement.component.ts